/**
 * Базовый путь API расписаний относительно REACT_APP_ADV_API.
 * REACT_APP_ADV_API указывает на версионированный корень adv-бэкенда (…/api/v1),
 * поэтому здесь просто "schedules/". Проверено живым запросом (Task 1):
 * GET {ADV_API}/schedules/shifts/type/list → 401 (маршрут есть),
 * GET {ADV_API}/api/v1/schedules/shifts/type/list → 404.
 * Если развёртывание сконфигурировано иначе, правится только эта строка.
 */
export const SCHEDULES_API_PATH = "schedules/"

/** Максимум по контракту для schedules/list. Ответ ровно на limit = возможный срез. */
export const SCHEDULES_LIST_LIMIT = 1000

/** Максимум по контракту для shifts/type/list. */
export const SHIFT_TYPES_LIMIT = 200

/** Пресеты длины периода в неделях. */
export const PERIOD_PRESETS: readonly number[] = [2, 4, 6]
export const DEFAULT_PERIOD_WEEKS = 4
